const IFCA_STATUSES = [
  { text: 'Not Initiated', value: 'none' },
  { text: 'Synchronizing', value: 'syncing' },
  { text: 'Success', value: 'success' },
  { text: 'Failed', value: 'failed' },
];
export default IFCA_STATUSES;



// WEBPACK FOOTER //
// ./src/constants/ifcaStatuses.js